import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AddBooking from "./AddBooking";
import Booking from "./Booking";
import BookingFormDownload from "./BookingFormDownload";
import ViewServiceReq from "../leads/ViewServiceReq";
import HospitalPreview from "../leads/HospitalPreview";
import CompanyPreview from "../leads/CompanyPreview";
import EditHospitalProfile from "../leads/EditHospitalProfile";
import EventPreview from "../leads/EventPreview";
import EditCompany from "../leads/EditCompany";
import EditEvent from "../leads/EditEvent";
import ServiceDetails from "../Proposals/ServiceDetails";
import AddProposal from "../Proposals/AddProposal";

const ViewBooking = lazy(() => import("../Booking/ViewBooking"));

const BookedModule = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="addBooking" element={<AddBooking />} />
        <Route path="downloadBookForm" element={<BookingFormDownload />} />
        <Route path="confirmedBooking" element={<ViewBooking />} />
        <Route path="viewBooking" element={<ViewBooking />} />
        <Route path="viewBooking/addProposal" element={<AddProposal />} />
        <Route path="expiredService" element={<ViewBooking />} />
        <Route path="booking" element={<Booking />} />
        <Route path="viewBooking/viewServiceReq" element={<ViewServiceReq />} />
        <Route path="viewBooking/previewHospital" element={<HospitalPreview />} />
        <Route path="confirmedBooking/previewHospital" element={<HospitalPreview />} />
        <Route path="viewBooking/previewCompany" element={<CompanyPreview />} />
        <Route path="confirmedBooking/previewCompany" element={<CompanyPreview />} />
        <Route path="viewBooking/eventPreview" element={<EventPreview />} />
        <Route path="confirmedBooking/editHospitals" element={<EditHospitalProfile />} />
        <Route path="viewBooking/editHospitals" element={<EditHospitalProfile />} />
        <Route path="viewBooking/editCompany" element={<EditCompany />} />
        <Route path="confirmedBooking/editCompany" element={<EditCompany />} />
        <Route path="viewBooking/editEvent" element={<EditEvent />} />
        <Route path="viewBooking/serviceDetails" element={<ServiceDetails />} />
        <Route path="confirmedBooking/serviceDetails" element={<ServiceDetails />} />
      </Routes>
    </Suspense>
  );
};

export default BookedModule;
